import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
    import news from '@/views/modules/news/list'
    import shequxinxi from '@/views/modules/shequxinxi/list'
    import cheweixinxi from '@/views/modules/cheweixinxi/list'
    import messages from '@/views/modules/messages/list'
    import config from '@/views/modules/config/list'
    import loufangxinxi from '@/views/modules/loufangxinxi/list'
    import yezhuxinxi from '@/views/modules/yezhuxinxi/list'
    import xiaoqufangke from '@/views/modules/xiaoqufangke/list'
    import tongji from '@/views/modules/tongji/list'
    import gonggongsheshi from '@/views/modules/gonggongsheshi/list'
    import huzhuxuqiu from '@/views/modules/huzhuxuqiu/list'
    import shequhuodong from '@/views/modules/shequhuodong/list'


//2.配置路由   注意：名字
const routes = [{
    path: '/index',
    name: '首页',
    component: Index,
    children: [{
      // 这里不设置值，是把main作为默认页面
      path: '/',
      name: '首页',
      component: Home,
      meta: {icon:'', title:'center'}
    }, {
      path: '/updatePassword',
      name: '修改密码',
      component: UpdatePassword,
      meta: {icon:'', title:'updatePassword'}
    }, {
      path: '/pay',
      name: '支付',
      component: pay,
      meta: {icon:'', title:'pay'}
    }, {
      path: '/center',
      name: '个人信息',
      component: center,
      meta: {icon:'', title:'center'}
    }
      ,{
	path: '/news',
        name: '通知公告',
        component: news
      }
      ,{
	path: '/loufangxinxi',
        name: '房屋信息',
        component: loufangxinxi
      }
      ,{
	path: '/yezhuxinxi',
        name: '业主信息',
        component: yezhuxinxi
      }
      ,{
	path: '/tongji',
        name: '统计分析',
        component: tongji
      }
      ,{
	path: '/gonggongsheshi',
        name: '公共设施',
        component: gonggongsheshi
      }
      ,{
	path: '/huzhuxuqiu',
        name: '互助需求',
        component: huzhuxuqiu
      }
      ,{
	path: '/shequhuodong',
        name: '社区活动',
        component: shequhuodong
      }
      ,{
	path: '/xiaoqufangke',
        name: '小区访客',
        component: xiaoqufangke
      }
      ,{
	path: '/shequxinxi',
        name: '社区活动',
        component: shequxinxi
      }
      ,{
	path: '/cheweixinxi',
        name: '车位信息',
        component: cheweixinxi
      }
      ,{
	path: '/messages',
        name: '报修和投诉管理',
        component: messages
      }
      ,{
	path: '/config',
        name: '轮播图管理',
        component: config
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {icon:'', title:'login'}
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {icon:'', title:'register'}
  },
  {
    path: '/',
    name: '首页',
    redirect: '/index'
  }, /*默认跳转路由*/
  {
    path: '*',
    component: NotFound
  }
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
  mode: 'hash',
  /*hash模式改为history*/
  routes // （缩写）相当于 routes: routes
})

export default router;
